import {
  getShop
} from "./chunk-UA6USR6Y.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/getShopById/getShopById.ts
async function getShopById(idOrShortId, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "getShop");
  try {
    const shop = await getShop(idOrShortId, _apiConfig);
    return {
      status: "success",
      data: shop
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getShopById
};
